class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.modalToggleEl = this.querySelector('.modal__toggle');
    this.modalContentEl = this.querySelector('.modal__content');
    this.closeButtonEl = this.querySelector('.modal__close-button');

    this.modalContentEl?.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.modalToggleEl?.addEventListener('click', this.onToggleClick.bind(this));
    this.closeButtonEl?.addEventListener('click', this.close.bind(this));
  }

  isOpen() {
    return this.classList.contains('open');
  }

  onToggleClick(event) {
    event.preventDefault();

    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.classList.add('open');

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const tabIndexElement = this.querySelector('[tabindex="-1"]');
    const inputElement = this.querySelector('input:not([type="hidden"])');

    if (tabIndexElement || inputElement) {
      trapFocus(tabIndexElement || inputElement, inputElement);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.modalToggle : null);

    this.classList.remove('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }

    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
